import {Component} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute} from '@angular/router';
import {BaseFeatureWelcomeComponent} from '@catapp/shared/feature/create-form-wizards/base-feature-welcome.component';
import {FeatureTypeService} from '@catmodules/core/services/index';
import {FeatureUnitsService} from '@catmodules/models/feature-units/services/feature-units.service';
import {UnitsService} from '@catmodules/models/units/services/units.service';
import {SelectItem} from 'primeng/primeng';
import {isNullOrUndefined} from 'util';
import {FeatureGgwFixedRoutesService} from "@catmodels/ggw-fixed-routes/services/feature-ggw-fixed-routes.service";
import {extractDataFromProperty, sortByLabelFunc} from "@catcore/utils";
import {FeatureGgwDynRouteTemplateService} from "@catmodels/ggw-dynamic-routes/services/feature-ggw-dyn-route-templates.service";
import {GgwDynamicRouteTemplateService} from "@catmodels/ggw-dynamic-routes/services/ggw-dynamic-route-templates.service";

/**
 * A component to fast create a new dynamic route template for the currently in use Feature
 */
@Component({
  templateUrl: './feature-dynamic-routes-landing.component.html',
})
export class FeatureDynamicRoutesLandingComponent extends BaseFeatureWelcomeComponent {

  /**
   * The self-name to be used throughout the displayed elements.
   * Reference to the current used type of model
   * @type {string}
   */
  selfTitle = 'Dynamic Route Template';

  /**
   * The title used by the form wizard component
   * @type {string}
   */
  title = `New ${this.selfTitle}`;

  /**
   * All potential model templates
   */
  ggwDynamicRouteTemplateModels: SelectItem[];

  /**
   * Label names to be used by form input elements.
   */
  labels = {
    templateModel: 'Template Model',
    buttons: {
      last: `Save the ${this.selfTitle}`,
    },
  };

  outputOptions = [];

  private staticInputOptions = [
  ];

  inputOptions = [
    ...this.staticInputOptions
  ];

  /**
   * Returns true if the current form object is ready.
   * Ready means all necessary data that is required to display and use the form, is available
   * @returns {boolean}
   */
  get formIsReady() {
    let isReady = !isNullOrUndefined(this.getFeature());
    isReady = isReady && !isNullOrUndefined(this.ggwDynamicRouteTemplateModels);
    return isReady;
  }

  resetAfterComplete = true;

  constructor(private route: ActivatedRoute,
              featureService: FeatureTypeService,
              private ggwDynamicRouteTemplateService: GgwDynamicRouteTemplateService,
              private featureGgwDynRouteTemplateService: FeatureGgwDynRouteTemplateService) {
    super(featureService);

    this.form = new FormGroup({
      model: new FormControl('', [Validators.required]),
    });

  }

  /**
   * Executes the request to create a new entity
   *
   */
  /**
   * Creates a new entity
   *
   * The 'isVirtual' property needs to check explicitly because it can still be NULL if the form was reset on one point
   */
  saveNewEntity() {
    this.featureGgwDynRouteTemplateService
      .create(this.form.value, this.getFeature())
      .subscribe((dynRouteTemplate) => {
        this.setCurrentEntity(dynRouteTemplate);
        this.setIsCompleted(dynRouteTemplate !== null);
        this.getFeatureService().refreshCurrent();
      });
  }

  /**
   * Updates the current usable GgwDevices items as soon as a new item list is available
   */
  beforeDisplayProperties(): void {
    this
      .ggwDynamicRouteTemplateService
      .getAll()
      .subscribe((dynamicRouteTemplates: any[]) => {
        this.updateDynamicRouteSelectItems(dynamicRouteTemplates);
      });
  }

  validatePropertiesView() {
  }

  templateSelected(event) {
  }

  private updateDynamicRouteSelectItems(dynamicRouteTemplateModels) {
    this.ggwDynamicRouteTemplateModels = [];
    dynamicRouteTemplateModels
      .forEach((item) => {
        const itemLabel = item.name;
        this.ggwDynamicRouteTemplateModels.push({label: itemLabel, value: item});
    });

    this.ggwDynamicRouteTemplateModels.sort(sortByLabelFunc);
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/features/components/landing-pages/feature-dynamic-routes-landing/feature-dynamic-routes-landing.component.ts